import styled from 'styled-components';
import { colors, typography, spacing, borderRadius, shadows, breakpoints } from '../../styles/theme';
import { fadeInUp } from '../../styles/animations';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: ${spacing.lg};

  @media (max-width: ${breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${spacing.sm};
  padding: ${spacing.xl};
  background: ${colors.neutral.white};
  border-radius: ${borderRadius['2xl']};
  box-shadow: ${shadows.card};
  // backwards (not both) fill: entrance anim only fills during the delay so the
  // completed animation does not pin transform and kill the hover lift.
  animation: ${fadeInUp} 0.6s ease-out backwards;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: ${shadows.orange};
  }
`;

export const Icon = styled.div`
  width: 50px;
  height: 50px;
  border-radius: ${borderRadius.full};
  background: ${colors.gradients.orange};
  color: ${colors.neutral.white};
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${shadows.orange};
  margin-bottom: ${spacing.xs};
`;

export const Title = styled.h3`
  font-size: ${typography.fontSize.lg};
  font-weight: ${typography.fontWeight.bold};
  color: ${colors.primary.teal};
  margin: 0;
`;

export const Text = styled.p`
  font-size: ${typography.fontSize.base};
  color: ${colors.neutral.gray600};
  line-height: ${typography.lineHeight.relaxed};
  margin: 0;
`;
